import React, {createContext, useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import * as _ from 'lodash';
import {FormikProvider, useFormik} from 'formik';
import {showGlobalMessage} from '../../_common/components/GlobalMessage/actions/showGlobalMessage';
import {validate} from '../utils/validate';
import {messages as M} from '../../../../_metronic/i18n/messages';
import * as actions from '../actions/ContactsActions';

const EditContactContext = createContext('');

export function useEditContactContext() {
  return useContext(EditContactContext);
}

export function EditContactProvider({children, contactID}) {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  const getData = () => {
    actions.getContactData(contactID).then(setData);
  };

  const formik = useFormik({
    initialValues: {
      contactID: _.get(data, 'contactID', ''),
      firstName: _.get(data, 'firstName', ''),
      lastName: _.get(data, 'lastName', ''),
      phone: _.get(data, 'phone', ''),
      email: _.get(data, 'email', ''),
      job: _.get(data, 'job', ''),
      organization: _.get(data, 'organization', ''),
      address: _.get(data, 'address', ''),
      statusID: _.get(data, 'statusID', 1)
    },
    enableReinitialize: true,
    validate: values => validate(values, formik.initialValues),
    onSubmit: () => {
    },
  });

  const editContact = async () => {
    try {
      await dispatch(actions.addEditContact(formik.values));
      await dispatch(showGlobalMessage('success', M['0']));
    } catch (e) {
      console.error('editContact:', e);
    }
  };

  return (
    <EditContactContext.Provider value={{
      formik,
      getData,
      editContact,
      fullName: [
        _.get(data, 'firstName', ''),
        _.get(data, 'lastName', ''),
      ].filter(Boolean).join(' '),
    }}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </EditContactContext.Provider>
  );
}